import styled from 'styled-components'
import { SelectListItem } from './StyledSelectList'
import HoroscopeLink from './StyledHoroscopeLink'

const makeBackgroundPosition = (background, yOffset = 0) => {
  return `${background.x}px ${background.y + yOffset}px`
}

export default styled.div`
  background-image: url(${props => props.theme.horoscopes.background});
  background-position: ${props => makeBackgroundPosition(props.backgroundPositions)};
  background-repeat: no-repeat;
  height: 56px;
  margin-right: 5px;
  width: 60px;

  ${SelectListItem}:hover &, ${HoroscopeLink}:hover & {
    background-position: ${props => makeBackgroundPosition(props.backgroundPositions, -150)};
  }
`
